import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AppPaths } from '@ftr/routing-paths'
import { RedirectSitePortalToHomeIfPublicNavigationGuard } from '@ftr/ui-user'
import { HelpModule } from '../../lib/help.module'
import { HelpPage } from './help.page'
import { LoggedInResolver } from './is-logged-in.resolver'

@NgModule({
  declarations: [HelpPage],
  providers: [LoggedInResolver],
  imports: [
    CommonModule,
    HelpModule,
    RouterModule.forChild([
      {
        path: AppPaths.Help,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
        data: {
          title: 'Help & Support',
          breadcrumb: 'Help & Support',
        },
        resolve: {
          isLoggedIn: LoggedInResolver,
        },
        component: HelpPage,
      },
    ]),
  ],
})
export class HelpPageModule {}
